module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/grace-pinkston-e2a2b4c4a68e53e8173262f32b789c09.jpg";